import { parseDate } from "@internationalized/date";
import { withErrorBoundary } from "app/ErrorBoundary/ErrorBoundaryDashboard";
import { format } from "date-fns";
import ISirkNote from "features/CenterContent/RoleContent/ISirk/ISirkNote";
import { EventsOverviewButtonAndModal } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/UpcomingEventsModal/EventsOverviewButtonAndModal";
import { SharedGridStyle } from "features/CenterContent/shared/MainContentGrid";
import { useState } from "react";
import { FailureMessage } from "shared/components/feedback/FailureMessage/FailureMessage";
import SkeletonLoader from "shared/components/feedback/SkeletonLoader/SkeletonLoader";
import {
  Box,
  DropsDatePicker,
  Field,
  Heading,
  Stack,
} from "shared/components/Spor";
import { ObtrusiveScrollCss } from "shared/components/transitions/scroll";
import { Text } from "shared/components/typography/TitleStyles";
import styled from "styled-components";
import { useISirkView } from "features/CenterContent/RoleContent/ISirk/useISirkData";
import type { IncidentNote } from "features/CenterContent/RoleContent/ISirk/types";

const ISirkWrapper = styled.div`
  ${SharedGridStyle};
  height: 100%;
  overflow-y: scroll;
  color: ${({ theme }) => theme.colorTextMain};
  ${ObtrusiveScrollCss};
`;

const ContentWrapper = styled(Stack)`
  height: 100%;
  max-width: 1000px;
`;

const ISirkView = () => {
  const [selectedDate, setSelectedDate] = useState(
    format(new Date(), "yyyy-MM-dd"),
  );

  const { data, status } = useISirkView(selectedDate);

  const getContent = () => {
    switch (status) {
      case "pending":
        return <SkeletonLoader skeletonType="list" />;
      case "success": {
        const { incidentNotes } = data!;
        return incidentNotes.length ? (
          incidentNotes.map((note: IncidentNote) => (
            <ISirkNote key={note.identifier} {...note} />
          ))
        ) : (
          <Text>Fant ingen gjeldende I-Sirk for {selectedDate}.</Text>
        );
      }
      case "error":
        return <FailureMessage />;
    }
  };

  return (
    <ISirkWrapper>
      <ContentWrapper pt="12px" px="6px">
        <EventsOverviewButtonAndModal />
        <Heading as="h2" variant="sm" style={{ fontWeight: "bold" }}>
          I-Sirk
        </Heading>
        <Field label="Viser I-Sirk som er aktive" mb="18px">
          <Box>
            <DropsDatePicker
              label="Dato"
              variant="core"
              minHeight="54px"
              value={parseDate(selectedDate.toString())}
              onValueChange={(date) => {
                if (date !== null) setSelectedDate(date.toString());
              }}
              withPortal
            />
          </Box>
        </Field>
        {getContent()}
      </ContentWrapper>
    </ISirkWrapper>
  );
};

export default withErrorBoundary(ISirkView);
